const history = require("history").createBrowserHistory();
/*
  This is the history object used to initialize store and also supplied into
  the router component.
*/
export default history;
